const mapStateToProps = (state) => ({
  departamentoICO: state.asociarUsuarios.departamentoICO,
  municipioICO: state.asociarUsuarios.municipioICO,
});
export default mapStateToProps;
